import {Component} from "@angular/core";

@Component({
    selector: "fui-fragments",
    styleUrls: ["./fragments.component.scss"],
    templateUrl: "./fragments.component.html"
})
export class FUIFragmentsComponent {
}
